module.exports = __webpack_public_path__ + "img/p3.5b70013f.png";